var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1cc9f2b5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-col items-start justify-center" };
const _hoisted_2 = { class: "text-sm text-gray-600" };
import * as Icons from '@gohighlevel/ghl-icons/24/outline';
export default /*#__PURE__*/ _defineComponent({
    __name: 'IconTextContainer',
    props: {
        id: String,
        text: String,
        title: String,
        primaryColor: Boolean,
        icon: String,
    },
    setup(__props) {
        const props = __props;
        // Destructure the imported Icons object into a new object called 'icons'
        const icons = __rest(Icons
        // Get the icon specified by the 'icon' prop from the 'icons' object
        , []);
        // Get the icon specified by the 'icon' prop from the 'icons' object
        const currentIcon = icons[props.icon];
        const mainContainerId = `${props.id}-main-container`;
        const iconId = `${props.id}-icon`;
        const titleId = `${props.id}-title`;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "flex space-x-3 mb-3",
                id: mainContainerId
            }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentIcon)), {
                    class: "text-gray-500 h-6 w-6",
                    id: iconId
                })),
                _createElementVNode("div", _hoisted_1, [
                    (__props.title)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "text-sm font-medium",
                            id: titleId,
                            style: _normalizeStyle({
                                paddingBottom: __props.text ? '5px' : '0px',
                                color: __props.primaryColor ? `var(--primary-700)` : 'var(--gray-700)',
                                cursor: __props.primaryColor ? 'pointer' : 'default',
                            })
                        }, _toDisplayString(__props.title), 5))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1)
                ])
            ]));
        };
    }
});
